import type { Pro014StepFourItem } from "@/@types/campaign";
import type { IGradeTarget, IGradeTargetPayload } from "@/@types/campaign-grade";

const WILDCARD_KEY = "*";
const KEY_SEPARATOR = "|";
const LIST_SEPARATOR = ",";

export const gradeTargetKey = (grade: IGradeTarget): string =>
  `${grade.color ?? WILDCARD_KEY}${KEY_SEPARATOR}${grade.size ?? WILDCARD_KEY}`;

const sortedKeys = (grades: IGradeTarget[] | undefined): string =>
  (grades ?? []).map(gradeTargetKey).sort().join(LIST_SEPARATOR);

export const gradesDiffer = (before?: IGradeTarget[], after?: IGradeTarget[]): boolean =>
  sortedKeys(before) !== sortedKeys(after);

export const hasGrade = (item: Pick<Pro014StepFourItem, "grades">): boolean =>
  (item.grades?.length ?? 0) > 0;

export const toGradeTargetPayloads = (
  itemCode: string,
  grades: IGradeTarget[] | undefined,
): IGradeTargetPayload[] =>
  (grades ?? []).map((grade: IGradeTarget) => ({
    itemCode,
    color: grade.color,
    size: grade.size,
  }));

export const collectGradeTargets = (items: Pro014StepFourItem[]): IGradeTargetPayload[] =>
  items.flatMap((item: Pro014StepFourItem) => toGradeTargetPayloads(item.sku, item.grades));

export const findItemsWithoutGrade = (items: Pro014StepFourItem[]): string[] =>
  items.filter((item: Pro014StepFourItem) => !hasGrade(item)).map((item) => item.sku);
